export * from './smartcitizen.controller';
import basic1 from './basic1.html';
import basic2 from './basic2.html';
import basic3 from './basic3.html';
import collaborators from './collaborators.html';

export { basic1, basic2, basic3, collaborators }
